var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Other stuff")]),_c('div',{staticStyle:{"margin-bottom":"30px"}},[_vm._v(" And here are some other stuff I've made or heavily contributed to, which are totally different than the stuff from earlier. ")]),_c('ProjectsList',{attrs:{"projects":_vm.projects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }